export default {
  BORGUN: 'borgun',
  VALITOR: 'valitor',
  STRIPE: 'stripe',
  NETS: 'nets',
  RAPYD: 'rapyd',
};
